import type { OrgModule } from '@trashlab/sitesapp/src/organizations/types';

// Organization modules
import * as _default from '@trashlab/sitesapp/src/organizations/_default/index';
import * as bestDeal from '@trashlab/sitesapp/src/organizations/best-deal/index';
import * as denversiteworks from '@trashlab/sitesapp/src/organizations/denversiteworks/index';
import * as fasttrac from '@trashlab/sitesapp/src/organizations/fasttrac/index';
import * as fulltilt from '@trashlab/sitesapp/src/organizations/fulltilt/index';
import * as junkRescue from '@trashlab/sitesapp/src/organizations/junk-rescue/index';
import * as lakeAllenHenry from '@trashlab/sitesapp/src/organizations/lake-allen-henry/index';
import * as patriot from '@trashlab/sitesapp/src/organizations/patriot/index';
import * as piedmont from '@trashlab/sitesapp/src/organizations/piedmont/index';
import * as redebins from '@trashlab/sitesapp/src/organizations/redebins/index';

// Map org IDs to their modules
const ORG_MAP: Record<string, OrgModule> = {
  // BEST DEAL DUMPSTERS, LLC
  'd74bb19c-004b-479d-adaa-9e846d25dac7': bestDeal,
  // DenverSiteWorks
  'ba01fc33-e5c0-428d-867c-0a16c25c2d74': denversiteworks,
  // Fast Trac Rolloff
  '430e3255-c644-42e6-ae81-4435ad376933': fasttrac,
  // FULLTILT Dumpster Services LLC
  '9c35bacc-aca4-420d-a47c-0f9ea74e090c': fulltilt,
  // Junk Rescue
  '9b86b1d3-06db-4643-881a-70efbe1d737d': junkRescue,
  // Lake Allen Henry Waste Services
  '595e1ac9-65d2-44be-8406-9bea43940b7c': lakeAllenHenry,
  // Patriot Disposal Phoenix
  '5a577204-5904-43db-8939-4588a9a2e1d0': patriot,
  // Piedmont Environmental
  '7bccd47a-5ba4-4a63-9df7-d0eb16e955ac': piedmont,
  // RED-E-BINS USA LLC
  'c415a539-92fb-4813-933e-6c83f7656ce3': redebins,
};

export const defaultOrg: OrgModule = _default;

export const getOrgModule = (orgId: string | undefined): OrgModule => {
  if (!orgId) return defaultOrg;
  return ORG_MAP[orgId] ?? defaultOrg;
};

const ALL_ORGS = [_default, bestDeal, denversiteworks, fasttrac, fulltilt, junkRescue, lakeAllenHenry, patriot, piedmont, redebins];

// Collect all unique route paths across all orgs for route registration
export const getAllRoutePaths = (): string[] => {
  const paths = new Set<string>();
  for (const org of ALL_ORGS) {
    for (const path of Object.keys(org.routes)) {
      paths.add(path);
    }
  }
  return Array.from(paths);
};

// Get the first route config found for a path across all orgs
// Used for getting validateSearch/loader/params at route registration time
export const getFirstRouteConfig = (path: string) => {
  for (const org of ALL_ORGS) {
    const config = org.routes[path];
    if (config) return config;
  }
  return undefined;
};
